import { BaseEntity } from "BaseEntity"
import { SectorDTO, ImpactedPlantDTO } from "models"
import { ContainmentHoldDTO } from "./containmentHold"

export type ContainmentImpactedSectorTypeDTO = {
	sector: BaseEntity;
	type: BaseEntity;
}

export class ContainmentDTO extends BaseEntity {
	sector: SectorDTO; // the sector entity
	sectorType: any; 
	impactedPlants: ImpactedPlantDTO[];
	impactedSectorTypes: ContainmentImpactedSectorTypeDTO[];
	reason: BaseEntity;
	status: BaseEntity;
	friendlyId: string;
	createUser: BaseEntity;
	updateUser: BaseEntity;
	totalSerialCount?: int;
	sourceSystem?: string;
	initial: ContainmentHoldDTO;
	subsequent: ContainmentHoldDTO;
}
